import { ChangeEvent, FC, useState } from 'react';
import { css } from '@emotion/css';
import colors from '@prezzee/ribbon-ui/lib/theme/foundations/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EMPTY_STRING } from 'common/utils/string';

interface Props {
  placeholder: string;
  handleSearchChange: (value: string) => void;
}

const Styles = {
  container: css`
    position: relative;
    padding: 12px 0;
    margin: 0 16px;
  `,
  search: css`
    border: 1px solid ${colors.purple[400]};
    border-radius: 25px;
    padding: 13px 18px 13px 24px;
    color: ${colors.gray[600]};
    width: 100%;
    font-size: 16px;
    line-height: 24px;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${colors.gray[600]};
    }
  `,
  icon: hidden => css`
    ${hidden ? 'display: none;' : ''}
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 18px;
    cursor: pointer;
  `,
};

const SelectFilterSearch: FC<Props> = ({ placeholder, handleSearchChange }) => {
  let [value, setValue] = useState(EMPTY_STRING);
  let isIconHidden = value !== EMPTY_STRING;

  return (
    <div className={Styles.container}>
      <input
        value={value}
        className={Styles.search}
        type="search"
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          let searchValue = e.target.value;
          setValue(searchValue);
          handleSearchChange(searchValue);
        }}
      />
      <FontAwesomeIcon icon={['far', 'search']} className={Styles.icon(isIconHidden)} size="sm" />
    </div>
  );
};

export default SelectFilterSearch;
